// const NODE_ENV = process.env.NODE_ENV;
// 是否开发环境
// const isDev = NODE_ENV === "development";

export const baseConfig = {
    baseURL: "/hicity/",
};

